// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

export const bankCardSlice = createSlice({
  name: "bankCard",
  initialState: {
    refetch: false,
  },
  reducers: {
    handleBankCardData: (state) => {
      state.refetch = !state.refetch;
    },
  },
});

export const { handleBankCardData } = bankCardSlice.actions;

export default bankCardSlice.reducer;
